import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, TextField, Button, Paper, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import client from '../../utils/client';
import Alert from '../../utils/alert';
import errorToStr from '../../utils/errorToStr';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2),
    },
    form: {
        display: 'flex',
        gap: theme.spacing(3),
        alignItems: 'flex-start',
        flexWrap: 'wrap',
    },
    formControls: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        flex: 1,
        minWidth: '300px',
    },
    select: {
        minWidth: '200px',
    },
    textarea: {
        minWidth: '400px',
        minHeight: '120px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '300px',
        },
    },
    button: {
        textTransform: 'none',
        fontSize: '1.4rem',
        padding: theme.spacing(1.5, 3),
        height: 'fit-content',
        alignSelf: 'flex-start',
    },
}));

const SendNotifications = () => {
    const classes = useStyles();
    const [message, setMessage] = useState('');
    const [user_type, setUserType] = useState('');

    const handleChange = e => {
        setMessage(e.target.value);
    }

    const handleTypeChange = e => {
        setUserType(e.target.value);
    }

    const handleClick = () => {
        let data = {
            message: message,
            user_type: user_type
        };

        Alert.confirm(`UserType:${user_type} にNotification を送信します。`)
            .then((result) => {
                if (result.value) {
                    client.post('admin/sendNotifications', data)
                        .then(res => {
                            Alert.success("Sent!!");
                        })
                        .catch(error => {
                            Alert.error(errorToStr(error));
                        })
                }
            })
    }

    return (
        <Paper className={classes.container}>
            <Box component="form" className={classes.form}>
                <Box className={classes.formControls}>
                    <FormControl variant="outlined" className={classes.select}>
                        <InputLabel>User Type</InputLabel>
                        <Select
                            name="user_type"
                            value={user_type}
                            onChange={handleTypeChange}
                            label="User Type"
                        >
                            <MenuItem value="">
                                <em>Select user type</em>
                            </MenuItem>
                            <MenuItem value="Business">Business</MenuItem>
                            <MenuItem value="Personal">Personal</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        name="message"
                        label="Message"
                        value={message}
                        onChange={handleChange}
                        variant="outlined"
                        multiline
                        rows={5}
                        className={classes.textarea}
                        placeholder="Enter notification message"
                    />
                </Box>
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={handleClick}
                    className={classes.button}
                    disabled={!message || !user_type}
                >
                    Send
                </Button>
            </Box>
        </Paper>
    )
}

export default SendNotifications;
